import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from "@material-ui/core/styles";
import { Box, Checkbox, Grid, IconButton, Typography } from "@material-ui/core";
import classNames from 'classnames';
import { useTranslation } from "react-i18next";
import { Formik, Field } from "formik";
import AppColor from "../../../../utilities/AppColor";
import { DAYS, MASK, SYSTEM_ROLE, WORKER_TYPE } from "../../../../config/AppConfig";
import AppInput from "../../../../components/Input/AppInput";
import AppUtil from "../../../../utilities/AppUtil";
import * as Yup from 'yup';
import AppButton from "../../../../components/CustomButtons/AppButton";
import moment from 'moment';

import { fetchAvailability } from "../../../../store/slices/schedule";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getAuthInfo } from "../../../../store/slices/auth";
import { fetchAllParticipants } from "../../../../store/slices/coordinatorParticipant";
import Loading from "../../../../components/Common/Loading";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import { reduceCalculatePriceSingleBooking } from "../../../../store/slices/rate";
import InputAutocompleteAddress from "../../../../components/Input/InputAutocompleteAddress";
import { showToast } from "../../../../store/slices/toast";
import { reduceAddBookingJob } from "../../../../store/slices/booking";
import { fetchClientDetail, fetchClientList } from "../../../../store/slices/client";
import { YupValidations } from 'utils/validate';
// import SelectTime from 'components/Select/SelectTime';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { fetchSupports } from "../../../../store/slices/worker";
import SelectField from 'components/Select/SelectField';
import AppDialog from 'components/Dialog/AppDialog';
import ShiftForm from './ShiftForm';
import { SHIFT_COLOR } from "config/AppConfig";



const DAY = {
  date: '',
  shift: []
}
const KEY = {
  conflict: 'conflict-',
  startEnd: 'start-end-'
}

const dayValidate = Yup.object().shape({
  date: Yup.string(),
  shift: Yup.array().of(Yup.object().shape({
    type: Yup.string(),
    start: Yup.date()
      .when('checked', (checked, schema) => {
        if (checked) {
          return schema
            .required("validation.required")
            .when('shiftType', (shiftType, schema) => {
              return schema
                .when('end', (end, schema) => {
                  if (end && end !== '') {
                    return schema.max(
                      moment(end).subtract(1, 'minutes').format('yyyy/MM/DD HH:mm'),
                      "validation.startTimeMustBeBeforeEndTime"
                    )
                  }
                })
            })
        }
      }),
    end: Yup.date()
      .when('checked', (checked, schema) => {
        if (checked) {
          return schema
            .required("validation.required")
            .when('shiftType', (shiftType, schema) => {
              return schema
                .when('start', (start, schema) => {
                  if (start && start !== '') {
                    return schema.min(
                      moment(start).add(1, 'minutes').format('yyyy/MM/DD HH:mm'),
                      "validation.endTimeMustBeAfterStartTime"
                    )
                  }
                })
            })
        }
      }),
    id: Yup.number(),
  }))
})

const INITIALIZE_FORM = Object.freeze({
  monday: { ...DAY },
  tuesday: { ...DAY },
  wednesday: { ...DAY },
  thursday: { ...DAY },
  friday: { ...DAY },
  saturday: { ...DAY },
  sunday: { ...DAY },
  specialty: '',
  support: '',
  job: {
    description: '',
    address1: '',
    address2: '',
    department: '',
    floor: '',
    phoneNumber: '',
    participantId: '',
    lat: '',
    lng: '',
    postalCode: ''
  }
});

const INITIALIZE_CALCULATED_PRICE = Object.freeze({
  dayTypes: [],
  totalHours: 0,
  totalPrice: 0
});
const LIST_SHIFT_TYPE = {
  'MORNING': 0,
  'AFTERNOON': 1,
  'EVENING': 2,
  'NIGHT': 3,
}

const BookingForm = props => {
  const {
    data
  } = props;
  const { t } = useTranslation();
  const { id } = useParams();
  const isMobile = AppUtil.mobileAndTabletCheck();
  const dispatch = useDispatch();
  const [initializeData, setInitializeData] = useState({ ...INITIALIZE_FORM })
  const [weeksData, setWeeksData] = useState(new Map());
  const [weeks, setWeeks] = useState([]);
  const [currentWeek, setCurrentWeek] = useState({});
  const [days, setDays] = useState(DAYS);
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [calculatedPrice, setCalculatedPrice] = useState(INITIALIZE_CALCULATED_PRICE);
  const [supports, setSupports] = useState([]);
  const availabilityForm = useRef();
  const user = useSelector(getAuthInfo);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(null);
  const [bookingHistoryList, setBookingHistoryList] = useState([]);
  // key = date + shiftType
  const [invalidMap, setInvalidMap] = useState(new Map());

  const [clientIds, setClientIds] = useState([]);
  const [newBooking, setNewBooking] = useState({});
  const [isOpenModalBooking, setIsOpenModalBooking] = useState(false);

  const isHospital = user.role === SYSTEM_ROLE.HOSPITAL_OTHER || user.role === SYSTEM_ROLE.HOSPITAL_ADMIN;
  const isCOP = user.role === SYSTEM_ROLE.PARTICIPANT || user.role === SYSTEM_ROLE.COORDINATOR_ADMIN || user.role === SYSTEM_ROLE.COORDINATOR_OTHER;
  const isCO = user.role === SYSTEM_ROLE.COORDINATOR_ADMIN || user.role === SYSTEM_ROLE.COORDINATOR_OTHER;
  const isCompany = user.role === SYSTEM_ROLE.COMPANY;

  const useStyles = makeStyles(() => ({
    textViewMoreBooking: {
      cursor: 'pointer',
      color: AppColor.blueLighten,
      fontSize: '13px'
    },
    boxEmpty: {
      opacity: 0
    },
    boxVisibilityIcon: {
      textAlign: 'center',
      '& :hover': {
        color: AppColor.darkBlue
      }
    },
    boxVisibilityIconTop: {
      alignItems: "start-end",
      textAlign: 'center',
      '& :hover': {
        color: AppColor.darkBlue
      }
    },
    boxVisibilityIconBottom: {
      alignItems: "flex-end",
      textAlign: 'center',
      '& :hover': {
        color: AppColor.darkBlue
      }
    },
    boxVisibilityIconCenter: {
      alignItems: "center",
      textAlign: 'center',
      '& :hover': {
        color: AppColor.darkBlue
      }
    },
    availabilityTitle: {
      color: AppColor.mainColor,
      fontSize: '34px',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      textAlign: 'center'
    },
    availabilityDate: {
      fontSize: '16px',
      color: 'black',
      textAlign: 'center'
    },
    availabilitySubTitle: {
      fontSize: '13px',
      fontWeight: 'normal',
      color: AppColor.pink
    },
    box1: {
      backgroundColor: '#F1EEEC',
      borderRadius: '15px'
    },
    box2: {
      backgroundColor: 'rgba(196, 196, 196, 0.12)',
      border: '1px solid rgba(0, 0, 0, 0.1)',
      boxSizing: 'border-box',
      borderRadius: '15px'
    },
    innerBox: {
      borderRight: '2px solid white',
      boxSizing: 'border-box'
    },
    innerBox2: {
      borderRight: '2px solid white',
      borderBottom: '2px solid white',
      boxSizing: 'border-box',
      minHeight: '125px'
    },
    innerBox3: {
      borderBottom: '2px solid white',
      boxSizing: 'border-box',
      minHeight: '125px'
    },
    innerBox4: {
      borderRight: '2px solid white',
      boxSizing: 'border-box',
      minHeight: '125px'
    },
    innerBox5: {
      boxSizing: 'border-box',
      minHeight: '125px'
    },
    w70: {
      width: '70%',
    },
    w30: {
      width: '30%'
    },
    title: {
      fontSize: '15px',
      fontWeight: 'bold',
      color: 'black',
      textAlign: 'center'
    },
    titlePurple: {
      fontSize: '15px',
      fontWeight: 'bold',
      color: AppColor.violet,
      textAlign: 'center'
    },
    subTitle: {
      fontSize: '16px',
      color: AppColor.darkPurple,
      opacity: '50%',
      textAlign: 'center'
    },
    date: {
      fontSize: '15px',
      color: 'rgba(0,0,0,0.7)',
      fontWeight: 'normal'
    },
    input: {
      margin: 0,
      '& .preview-time': {
        padding: '0 0.3rem'
      }
    },
    commonTitle: {
      fontSize: '25px',
      color: AppColor.darkPurple,
      fontWeight: 'normal',
      marginBottom: '15px'
    },
    commonText: {
      fontSize: '15px',
      fontWeight: 'normal',
      color: AppColor.black
    },
    totalBox: {
      border: '1px solid rgba(0, 0, 0, 0.2)',
      borderRadius: '12px',
      boxSizing: 'border-box'
    },
    weekSelect: {
      fontSize: '14px'
    },
    boxModal: {
      display: 'flex',
      alignItems: 'center',
      '& label': {
        minWidth: '40px'
      }
    },
    wrapShift: {
      "& .shiftInfo": {
        // margin: "-1rem -1rem 1rem -1rem",
        padding: "0.3rem 1rem",
        border: "1px solid #c4b5bc",
        borderRadius: 4,
        backgroundColor: AppColor.white,
        display: "flex",
        justifyContent: "space-between",
        width: '100%',
        cursor: "pointer",
        textAlign: 'center'
      },
      "& .shiftInfo.MORNING": {
        backgroundColor: SHIFT_COLOR.MORNING,
        color: '#fff'
      },
      "& .shiftInfo.AFTERNOON": {
        backgroundColor: SHIFT_COLOR.AFTERNOON,
        color: '#fff'
      },
      "& .shiftInfo.EVENING": {
        backgroundColor: SHIFT_COLOR.EVENING,
        color: '#fff'
      },
      "& .shiftInfo.NIGHT": {
        backgroundColor: SHIFT_COLOR.NIGHT,
        color: '#fff'
      },
    }
  }));

  const classes = useStyles();

  const _hasAvailability = (values) => {
    let check = false;
    weeksData.forEach((value, dataKey) => {
      if (dataKey !== currentWeek.week) {
        Object.keys(value).some(key => {
          if (typeof value[key] === 'object' && key !== 'job') {
            if (value[key].shift.length > 0) {
              check = true;
              return true;
            }
          }
        })
      }
    });
    Object.keys(values).some(key => {
      if (typeof values[key] === 'object' && key !== 'job') {
        if (values[key].shift.length > 0) {
          check = true;
          return true;
        }
      }
    })
    return check;
  }
  const _onSpecialtyChange = (specialtyId, values) => {
    if (!specialtyId) return;
    if (_hasAvailability(values) === false) {
      dispatch(showToast({
        message: t('toast.error.availability'),
        type: 'danger'
      }));
      return;
    }
    _calculatePrice({ specialtyId });
  }
  const _onSupportChange = (supportId, values) => {
    if (!supportId) return;
    if (_hasAvailability(values) === false) {
      dispatch(showToast({
        message: t('toast.error.availability'),
        type: 'danger'
      }));
      return;
    }
    _calculatePrice({ supportId });
  }
  const _calculatePrice = ({ specialtyId = '', supportId = '' }) => {
    const availabilities = [];
    weeksData.forEach((value, dataKey) => {
      if (dataKey !== currentWeek.week) {
        Object.keys(value).forEach(key => {
          if (typeof value[key] === 'object') {
            if (value[key].date && !moment(value[key].date).hours(12).isBefore(moment(new Date()).hours(0).minutes(0))) {
              value[key].shift.forEach(shift => {
                if (shift.available && shift.start && shift.end && shift.checked) {
                  const startTime = moment(shift.start);
                  const endTime = moment(shift.end);
                  const diff = endTime.diff(startTime, "hours", true);
                  if (shift.segments) {
                    availabilities.push({
                      date: value[key].date,
                      hours: diff,
                      shift: shift.type,
                      availabilitySegmentRequests: shift.segments
                    })
                  } else {
                    availabilities.push({
                      date: value[key].date,
                      hours: diff,
                      shift: shift.type
                    })
                  }

                }
              })
            }
          }
        })
      }
    });
    const formValues = { ...availabilityForm.current?.values };
    let isInvalidHours = false;
    formValues && Object.keys(formValues).forEach(key => {
      if (isInvalidHours) return
      if (typeof formValues[key] === 'object') {
        if (formValues[key].date && !moment(formValues[key].date).hours(12).isBefore(moment(new Date()).hours(0).minutes(0))) {
          formValues[key].shift.forEach(shift => {
            if (isInvalidHours) return
            if (shift.available && shift.start && shift.end && shift.checked) {
              const startTime = moment(shift.start);
              const endTime = moment(shift.end);
              const diff = endTime.diff(startTime, "hours", true);
              if (diff <= 0) {
                isInvalidHours = true;
                return;
              }
              if (shift.segments) {
                availabilities.push({
                  date: moment(formValues[key].date).format('YYYY/MM/DD'),
                  hours: diff,
                  shift: shift.type,
                  availabilitySegmentRequests: shift.segments
                })
              } else {
                availabilities.push({
                  date: moment(formValues[key].date).format('YYYY/MM/DD'),
                  hours: diff,
                  shift: shift.type
                })
              }

            }
          })
        }
      }
    })

    if (availabilities.length === 0 || isInvalidHours) {
      setCalculatedPrice(INITIALIZE_CALCULATED_PRICE);
      return;
    }

    const params = {
      availabilities
    }

    if (specialtyId) {
      params.accreditationId = data.accreditationId;
      params.specialtyId = specialtyId;
      params.yearsOfExperience = data.yearsOfExperience;
    }

    if (supportId) {
      params.supportId = supportId;
    }

    dispatch(reduceCalculatePriceSingleBooking(params)).then(({ payload }) => {
      payload ? setCalculatedPrice(payload) : setCalculatedPrice(INITIALIZE_CALCULATED_PRICE);
    });
  }
  // const _handleSelectChangeEndTime = (type, startTime, event, values, item, handleChange) => {
  //   const newValues = { ...values };
  //   const index = values?.[item.key]?.shift?.findIndex(e => e.type === type);
  //   const weekDate = moment(new Date(values?.[item.key].date));
  //   if (index > -1) {
  //     event = moment(new Date(event)).set({
  //       year: weekDate.get('year'),
  //       month: weekDate.get('month'),
  //       date: weekDate.get('date')
  //     });
  //     const momentStartTime = moment(startTime);

  //     if (moment.range(momentStartTime, event).diff('minutes') <= 0) {
  //       event.add(1, 'days');
  //     }
  //     newValues[item.key].shift[index]['end'] = event.format('YYYY/MM/DD HH:mm');

  //     // check getValidateMinMaxTime to setInvalidMap
  //     const textError = getValidateMinMaxTime(
  //       newValues[item.key].shift[index].start,
  //       newValues[item.key].shift[index].end
  //     )
  //     const newInvalidMap = new Map(invalidMap);
  //     const key = KEY.startEnd + momentStartTime.format('YYYY/MM/DD') + newValues[item.key].shift[index].shiftType;
  //     if (textError === null && newInvalidMap.has(key)) {
  //       newInvalidMap.delete(key);
  //       setInvalidMap(newInvalidMap);
  //     }
  //     if (textError !== null && !newInvalidMap.has(key)) {
  //       newInvalidMap.set(key, textError);
  //       setInvalidMap(newInvalidMap);
  //     }
  //     checkValidateBookingTime(newValues[item.key]?.shift, newValues[item.key]?.date)
  //   }

  //   handleChange({
  //     target: {
  //       name: item.key,
  //       value: newValues[item.key]
  //     }
  //   })
  //   setTimeout(() => {
  //     if (values.specialty || values.support) {
  //       _calculatePrice({ specialtyId: values.specialty, supportId: values.support })
  //     }
  //   }, 500)

  // }
  // const _handleSelectChangeStartTime = (type, endTime, event, values, item, handleChange) => {
  //   const newValues = { ...values };
  //   const index = values?.[item.key]?.shift?.findIndex(e => e.type === type);
  //   const weekDate = moment(new Date(values?.[item.key].date));
  //   if (index > -1) {
  //     event = moment(new Date(event)).set({
  //       year: weekDate.get('year'),
  //       month: weekDate.get('month'),
  //       date: weekDate.get('date')
  //     });
  //     const momentEndTime = moment(endTime);

  //     if (moment.range(event, momentEndTime).diff('minutes') <= 0) {
  //       momentEndTime.add(1, 'days');
  //       newValues[item.key].shift[index]['end'] = momentEndTime.format('YYYY/MM/DD HH:mm');
  //     }
  //     newValues[item.key].shift[index]['start'] = event.format('YYYY/MM/DD HH:mm');

  //     // check getValidateMinMaxTime to setInvalidMap
  //     const textError = getValidateMinMaxTime(
  //       newValues[item.key].shift[index].start,
  //       newValues[item.key].shift[index].end
  //     )
  //     const newInvalidMap = new Map(invalidMap);
  //     const key = KEY.startEnd + event.format('YYYY/MM/DD') + newValues[item.key].shift[index].shiftType;
  //     if (textError === null && newInvalidMap.has(key)) {
  //       newInvalidMap.delete(key);
  //       setInvalidMap(newInvalidMap);
  //     }
  //     if (textError !== null && !newInvalidMap.has(key)) {
  //       newInvalidMap.set(key, textError);
  //       setInvalidMap(newInvalidMap);
  //     }
  //     checkValidateBookingTime(newValues[item.key]?.shift, newValues[item.key]?.date)
  //   }

  //   handleChange({
  //     target: {
  //       name: item.key,
  //       value: newValues[item.key]
  //     }
  //   })
  //   setTimeout(() => {
  //     if (values.specialty || values.support) {
  //       _calculatePrice({ specialtyId: values.specialty, supportId: values.support })
  //     }
  //   }, 500)

  // }

  /**
   * Handle available checkbox change
   * @param type MORNING | AFTERNOON | EVENING | NIGHT
   * @param event
   * @param checked
   * @param values
   * @param item
   * @param id
   * @param handleChange
   * @param defaultValue
   * @private
   */
  // const _handleCheckboxChange = (type, event, checked, values, item, id, handleChange) => {
  //   let shift = [...values?.[item.key]?.shift];
  //   const date = moment(values?.[item.key]?.date);
  //   const index = shift.findIndex(e => e.type === type);
  //   let params = {
  //     ...shift[index],
  //     checked: checked,
  //   };
  //   const defaultStartTime = moment(new Date(date)).set({
  //     hour: 0,
  //     minute: 0,
  //     second: 0,
  //   });
  //   const defaultEndTime = moment(defaultStartTime.clone()).add(5, 'minutes');
  //   if (checked) {
  //     params.start = defaultStartTime;
  //     params.end = defaultEndTime;
  //   } else {
  //     params.start = '';
  //     params.startTime = '';
  //     params.end = '';
  //     params.endTime = '';
  //   }
  //   const newInvalidMap = new Map(invalidMap);
  //   const key = KEY.startEnd + moment(values && values[item.key] ? values[item.key].date : '').format('YYYY/MM/DD') + type;
  //   if (!checked && newInvalidMap.has(key)) {
  //     newInvalidMap.delete(key);
  //     setInvalidMap(newInvalidMap);
  //   }
  //   handleChange({
  //     target: {
  //       name: `${item.key}.shift[${index}]`,
  //       value: params
  //     }
  //   })
  //   const newValues = { ...values };
  //   newValues[item.key].shift[index] = params;
  //   checkValidateBookingTime(newValues[item.key].shift, newValues[item.key].date);

  //   if (values.specialty || values.support) {
  //     setTimeout(() => {
  //       _calculatePrice({ specialtyId: values.specialty, supportId: values.support });
  //     }, 500)
  //   }

  // }
  const _handleOpenBookingPopup = (type, event, checked, values, item, id, handleChange) => {
    let shift = [...values?.[item.key]?.shift];
    const date = moment(values?.[item.key]?.date);
    const index = shift.findIndex(e => e.type === type);
    const params = {
      ...shift[index],
      checked: checked,
      start: '',
      end: '',
      values: values,
      item: item,
      id: id,
      startDate: date,
      dayOfWeek: item.key.toUpperCase(),
      handleChange: handleChange
    };
    delete params.segments;
    setNewBooking(params);
    setIsOpenModalBooking(true);
  }
  const _handleUpdateBooking = (type, checked, values, item, id, handleChange) => {
    let shift = [...values?.[item.key]?.shift];
    const index = shift.findIndex(e => e.type === type);
    const date = moment(values?.[item.key]?.date);
    const params = {
      ...shift[index],
      values: values,
      item: item,
      id: id,
      dayOfWeek: item.key.toUpperCase(),
      startDate: date,
      handleChange: handleChange,
      isUpdate: true
    };
    setNewBooking(params);
    setIsOpenModalBooking(true);
  }

  const _handleClearDataBooking = (type, event, checked, values, item, id, handleChange) => {
    let shift = [...values?.[item.key]?.shift];
    // const date = moment(values?.[item.key]?.date);
    const index = shift.findIndex(e => e.type === type);
    let params = {
      ...shift[index],
      checked: checked,
      start: '',
      startTime: '',
      end: '',
      endTime: ''
    };
    const newInvalidMap = new Map(invalidMap);
    const key = KEY.startEnd + moment(values && values[item.key] ? values[item.key].date : '').format('YYYY/MM/DD') + type;
    if (!checked && newInvalidMap.has(key)) {
      newInvalidMap.delete(key);
      setInvalidMap(newInvalidMap);
    }
    handleChange({
      target: {
        name: `${item.key}.shift[${index}]`,
        value: params
      }
    })
    const newValues = { ...values };
    newValues[item.key].shift[index] = params;
    checkValidateBookingTime(newValues[item.key].shift, newValues[item.key].date);

    if (values.specialty || values.support) {
      setTimeout(() => {
        _calculatePrice({ specialtyId: values.specialty, supportId: values.support });
      }, 500)
    }
  }
  const _handleAddNewBooking = (data) => {
    const newValues = { ...data.values };
    const index = data.values?.[data.item.key]?.shift?.findIndex(e => e.type === data.type);
    newValues[data.item.key].shift[index].segments = data.segments;
    newValues[data.item.key].shift[index].checked = true;
    newValues.start = data.startTime;
    newValues.end = data.endTime;
    data.handleChange({
      target: {
        name: data.item.key,
        value: newValues[data.item.key]
      }
    })
    setTimeout(() => {
      if (data.values.specialty || data.values.support) {
        _calculatePrice({ specialtyId: data.values.specialty, supportId: data.values.support })
      }
    }, 500)
    setIsOpenModalBooking(false);
  }

  const _handleCloseModalBooking = (data) => {
    const newValues = { ...data.values };
    const index = data.values?.[data.item.key]?.shift?.findIndex(e => e.type === data.type);
    if (data.start !== '' && data.end !== '') {
      newValues[data.item.key].shift[index].start = data.start;
      newValues[data.item.key].shift[index].end = data.end;
      newValues[data.item.key].shift[index].checked = true;
      newValues[data.item.key].shift[index].segments = data.segments;
    } else {
      newValues[data.item.key].shift[index].start = undefined;
      newValues[data.item.key].shift[index].end = undefined;
      newValues[data.item.key].shift[index].checked = false;
      newValues[data.item.key].shift[index].segments = [];
    }

    data.handleChange({
      target: {
        name: data.item.key,
        value: newValues[data.item.key]
      }
    })
    setTimeout(() => {
      if (data.values.specialty || data.values.support) {
        _calculatePrice({ specialtyId: data.values.specialty, supportId: data.values.support })
      }
    }, 500)
    setIsOpenModalBooking(false);
  }
  const _submit = async (formData) => {
    if (!formData.job.lat || !formData.job.lng) {
      dispatch(showToast({
        message: t('toast.error.lat_lng'),
        type: 'danger'
      }))
      return;
    }
    setSubmitting(true);
    const jobAvailabilitiesRequests = [];
    let flag = null;
    weeksData.forEach((value, dataKey) => {
      Object.keys(formData).forEach(key => {
        if (dataKey !== currentWeek.week) {
          if (key !== 'support' && key !== 'specialty' && key !== 'job') {
            value[key].shift.forEach(shift => {
              if (shift.available && shift.start && shift.end && shift.checked) {
                const weekDate = moment(new Date(value[key].date));
                const startTime = moment(shift.start)
                const endTime = moment(shift.end);
                if (invalidMap.has(KEY.startEnd + weekDate.format('YYYY/MM/DD') + shift.shiftType)) {
                  flag = KEY.startEnd
                  return;
                }
                if (invalidMap.has(KEY.conflict + weekDate.format('YYYY/MM/DD') + shift.shiftType)) {
                  flag = KEY.conflict
                  return;
                }
                if (shift.segments) {
                  jobAvailabilitiesRequests.push({
                    start_time: startTime.format('YYYY/MM/DD HH:mm:ss'),
                    end_time: endTime.format('YYYY/MM/DD HH:mm:ss'),
                    schedule_id: shift.id,
                    availabilitySegmentRequests: shift.segments
                  })
                } else {
                  jobAvailabilitiesRequests.push({
                    start_time: startTime.format('YYYY/MM/DD HH:mm:ss'),
                    end_time: endTime.format('YYYY/MM/DD HH:mm:ss'),
                    schedule_id: shift.id
                  })
                }

              }
            })
          }
        }
      })
    });
    for (const key of Object.keys(formData)) {
      if (key !== 'support' && key !== 'specialty' && key !== 'job') {
        for (const shift of formData[key].shift) {
          if (shift.available && shift.start && shift.end && shift.checked) {
            // const weekDate = moment(new Date(formData[key].date));
            const startTime = moment(shift.start)
            const endTime = moment(shift.end);

            // if (invalidMap.has(KEY.startEnd + weekDate.format('YYYY/MM/DD') + shift.shiftType)) {
            //   flag = KEY.startEnd;
            //   console.log('here');
            //   dispatch(showToast({
            //     message: t('toast.error.conflictTime'),
            //     type: 'danger'
            //   }));
            //   setSubmitting(false);
            //   return;
            // }
            // if (invalidMap.has(KEY.conflict + weekDate.format('YYYY/MM/DD') + shift.shiftType)) {
            //   flag = KEY.conflict;
            //   console.log('here2');
            //   dispatch(showToast({
            //     message: t('toast.error.conflictTime'),
            //     type: 'danger'
            //   }));
            //   setSubmitting(false);
            //   return;
            // }
            if (shift.segments) {
              jobAvailabilitiesRequests.push({
                start_time: startTime.format('YYYY/MM/DD HH:mm:ss'),
                end_time: endTime.format('YYYY/MM/DD HH:mm:ss'),
                schedule_id: shift.id,
                availabilitySegmentRequests: shift.segments
              })
            } else {
              jobAvailabilitiesRequests.push({
                start_time: startTime.format('YYYY/MM/DD HH:mm:ss'),
                end_time: endTime.format('YYYY/MM/DD HH:mm:ss'),
                schedule_id: shift.id
              })
            }

          }
        }
      }
    }
    if (flag) {
      dispatch(showToast({
        message: t('toast.error.conflictTime'),
        type: 'danger'
      }));
      setSubmitting(false);
      return;
    }
    if (jobAvailabilitiesRequests.length === 0) {
      dispatch(showToast({
        message: t('toast.error.availability'),
        type: 'danger'
      }));
      setSubmitting(false);
      return;
    }

    let participant;
    if (isCOP) {
      participant = participants.find(e => e.id.toString() === formData.job.participantId.toString());
    }
    const request = {
      address1: formData.job.address1,
      address2: formData.job.address2,
      department: formData.job.department,
      floor: formData.job.floor,
      coordParticipantId: participant?.id || '',
      description: formData.job.description,
      jobAvailabilitiesRequests,
      lat: formData.job.lat,
      lng: formData.job.lng,
      phone: formData.job.phoneNumber,
      postalCode: formData.job.postalCode,
      specialtyId: formData.specialty,
      supportId: formData.support,
      workerId: data.id,
    };
    if (isCompany) {
      request.clientId = formData.job.participantId;
    }
    const { payload } = await dispatch(reduceAddBookingJob(request));
    setSubmitting(false);
    if (payload) {
      if (isCompany) {
        loadInits(currentWeek);
      } else {
        _loadClientDetail(currentWeek);
      }
      setCalculatedPrice(INITIALIZE_CALCULATED_PRICE);
      setWeeksData(new Map());
    }
  }
  const _createDays = (week) => {
    const days = DAYS.map((day, index) => ({
      ...day,
      date: moment(week.startDate).add(index, 'days').toDate()
    }));
    setDays(days);
    return [...days];
  }
  const _createWeeks = (newWeek) => {
    const week = newWeek ? newWeek : moment().isoWeek();
    const dayWeek = moment().isoWeek(week);
    const startDate = moment(dayWeek).startOf('isoWeek').isoWeekday(1);
    const endDate = moment(startDate).add(6, 'day');
    const formattedStart = startDate.format('DD/MM');
    const formattedEnd = endDate.format('DD/MM');
    const weekObject = {
      week,
      startDate: startDate,
      endDate: endDate,
      key: `${week}`,
      label: `${formattedStart} - ${formattedEnd}`
    };
    setCurrentWeek(weekObject);
    const newWeeks = [...weeks, weekObject];
    setWeeks(newWeeks);
    return weekObject;
  }
  const _loadAvailability = async (week) => {
    const { payload } = await dispatch(fetchAvailability({
      startDate: moment(week.startDate).format('YYYY/MM/DD'),
      endDate: moment(week.endDate).format('YYYY/MM/DD'),
      workerId: id
    }));
    return payload || [];
  }
  const _loadParticipants = async () => {
    if (isHospital || user.role === SYSTEM_ROLE.PARTICIPANT) {
      return;
    }
    const { payload } = await dispatch(fetchAllParticipants({ clientId: user.clientId }));
    payload && setParticipants(payload);
  }

  const loadClientIds = async () => {
    const result = await dispatch(fetchClientList(user.companyId));
    if (result.payload) {
      setClientIds(result.payload);
    }
  };

  const _loadClientDetail = async (currentWeek) => {
    let week, listDays;
    let bookingHistoryList = [];
    if (currentWeek) {
      week = currentWeek;
      listDays = days;
    } else {
      week = _createWeeks();
      listDays = _createDays(week);
    }

    const resultAvailability = await _loadAvailability(week);

    setLoading(false);
    const initForm = { ...INITIALIZE_FORM }
    listDays.forEach(item => {
      const date = moment(item.date).format('YYYY/MM/DD');
      const available = resultAvailability.find(e => moment(e.date).format('YYYY/MM/DD') === date.toString());
      if (available) {
        initForm[item.key] = {
          date: date,
          shift: available.shifts.map(itemShift => {
            const newList = itemShift.bookingList.map((booking) => {
              let start = booking.startTime && moment(booking.startTime);
              let end = booking.endTime && moment(booking.endTime);
              bookingHistoryList.push({
                day: item.key,
                shiftType: itemShift.shiftType,
                date: date,
                startTime: start,
                endTime: end
              });
              return {
                startTime: start,
                endTime: end
              }

            });
            return {
              ...itemShift,
              bookingList: newList,
              type: itemShift.shiftType,
              startDate: undefined,
              endDate: undefined,
              start: undefined,
              end: undefined,
              checked: false
            }
          })
        };
      } else {
        initForm[item.key] = { ...DAY };
      }
    });

    if (!isCO) {
      const { payload } = await dispatch(fetchClientDetail({ clientId: user.clientId, companyId: user.companyId }));

      if (!payload) return;
      const { client } = payload;
      availabilityForm.current && availabilityForm.current.handleReset();
      initForm['job'] = {
        ...INITIALIZE_FORM.job,
        address1: client.address1,
        address2: client.address2,
        phoneNumber: client.phone,
        lat: client.lat,
        lng: client.lng,
        postalCode: client.postalCode
      };
    }
    bookingHistoryList.sort(function (a, b) { return moment.range(b.startTime, a.startTime).diff('minutes') });
    setBookingHistoryList(bookingHistoryList);
    setInitializeData({
      ...initForm
    });
  }

  const loadInits = async (currentWeek) => {
    let week, listDays;
    let bookingHistoryList = [];
    if (currentWeek) {
      week = currentWeek;
      listDays = days;
    } else {
      week = _createWeeks();
      listDays = _createDays(week);
    }

    const resultAvailability = await _loadAvailability(week);

    setLoading(false);
    const initForm = { ...INITIALIZE_FORM }
    listDays.forEach(item => {
      const date = moment(item.date).format('YYYY/MM/DD');
      const available = resultAvailability.find(e => moment(e.date).format('YYYY/MM/DD') === date.toString());
      if (available) {
        initForm[item.key] = {
          date: date,
          shift: available.shifts.map(itemShift => {
            const newList = itemShift.bookingList.map((booking) => {
              let start = booking.startTime && moment(booking.startTime);
              let end = booking.endTime && moment(booking.endTime);
              bookingHistoryList.push({
                day: item.key,
                shiftType: itemShift.shiftType,
                date: date,
                startTime: start,
                endTime: end
              });
              return {
                startTime: start,
                endTime: end
              }

            });
            return {
              ...itemShift,
              bookingList: newList,
              type: itemShift.shiftType,
              startDate: undefined,
              endDate: undefined,
              start: undefined,
              end: undefined,
              checked: false
            }
          })
        };
      } else {
        initForm[item.key] = { ...DAY };
      }
    });
    bookingHistoryList.sort(function (a, b) { return moment.range(b.startTime, a.startTime).diff('minutes') });
    setBookingHistoryList(bookingHistoryList);
    setInitializeData({
      ...initForm
    });
  }

  const _loadSupports = async () => {
    const { payload } = await dispatch(fetchSupports());
    if (payload) {
      setSupports(payload.filter(item => item.isSupportForNurse));
    }
  }

  const renderDataModal = () => {
    return showModal && bookingHistoryList && (
      <Box >
        <AppButton
          label={moment(showModal.date).format('YYYY/MM/DD')}
          style={{
            marginRight: '0.5rem',
            cursor: 'default'
          }}
          mode="outlined"
          // disabled= {true}
          onClick={() => { }}
        />
        <div className={` row`} >
          {
            bookingHistoryList
              .filter((value) => (value.date === moment(showModal.date).format('YYYY/MM/DD') && value.shiftType === showModal.shiftType))
              .map((value, index) => (
                <React.Fragment key={index}>
                  <div className="col-lg-4 col-md-4" style={{ alignItems: 'center' }}>
                    <label style={{ marginLeft: '15px' }}>{index + 1}</label>
                  </div>
                  <div className="col-lg-8 col-md-8">
                    {`${value.startTime.format('HH:mm')} - ${value.endTime.format('HH:mm')}`}
                  </div>
                </React.Fragment>
              ))
          }

        </div>
      </Box>
    )
  }

  // const getLabelStartEndDate = (minTime, maxTime) => {
  //     const start = moment(minTime).format('HH:mm');
  //     const end = moment(maxTime).format('HH:mm');
  //     return (
  //         <Label className={'text-center'} style={{ color: AppColor.pink, margin: 0 }}>
  //             <span>{`${start} - ${end}`}</span>
  //         </Label>
  //     )
  // }

  const getValidateMinMaxTime = (start, end, minTime, maxTime) => {
    if ((start && moment.range(start, minTime).diff('minutes') > 0)) {
      return 'startTimeInvalid'
    }
    if ((end && moment.range(end, maxTime).diff('minutes') < 0)) {
      return 'endTimeInvalid'
    }

    return null;
  };

  /**
   * Handle check conflict BookingTime
   * @param arrShifts 
   */
  const checkValidateBookingTime = (arrShifts, date) => {
    if (!arrShifts) {
      return;
    }
    const newInvalidMap = new Map(invalidMap);
    let bookingHistoryList = [];
    const bookingList = arrShifts
      .filter(shift => ((shift.end && shift.start)))
      .map((shift) => {
        return {
          shiftType: shift.shiftType,
          startTime: moment(shift.start),
          endTime: moment(shift.end),
          id: shift.id
        }
      });
    // Get bookingHistoryList 
    bookingHistoryList = [...bookingList]
    for (const i in arrShifts) {
      if (arrShifts[i].bookingList.length > 0) {
        bookingHistoryList.splice(0, 0, ...arrShifts[i].bookingList);
      }
    }
    // begin validate
    for (const i in bookingList) {
      const key = KEY.conflict + moment(date).format('YYYY/MM/DD') + bookingList[i].shiftType;
      if (bookingHistoryList.length <= 1) {
        newInvalidMap.delete(key);
        setInvalidMap(newInvalidMap);
      }
      newInvalidMap.delete(key);
      for (const j in bookingHistoryList) {
        // if (bookingList[i].shiftType === bookingHistoryList[j].shiftType
        //   && bookingList[i].startTime.format('YYYY/MM/DD HH:mm') === bookingHistoryList[j].startTime.format('YYYY/MM/DD HH:mm')) {

        //   continue;
        // }
        if (bookingList[i].id !== bookingHistoryList[j].id) {
          if (!isConflictTime(bookingList[i], bookingHistoryList[j]) && newInvalidMap.has(key)) {
            newInvalidMap.delete(key);
            setInvalidMap(newInvalidMap);
          }
          if (isConflictTime(bookingList[i], bookingHistoryList[j]) && !newInvalidMap.has(key)) {
            newInvalidMap.set(key, 'conflictTime');
            setInvalidMap(newInvalidMap);
            break;
          }
        }
      }
    }
    setInvalidMap(newInvalidMap)
  };

  const isConflictTime = (time1, time2) => {

    // if ((moment(time1.startTime).isSame(moment(time2.startTime)) && moment(time1.endTime).isSame(moment(time2.endTime))) ||
    // moment(time1.startTime).isSame(moment(time2.startTime)) ||
    // moment(time1.endTime).isSame(moment(time2.endTime)) ||
    // moment(time1.startTime).isBetween(time2.startTime, time2.endTime) ||
    // moment(time1.endTime).isBetween(time2.startTime, time2.endTime) ||
    // moment(time2.startTime).isBetween(time1.startTime, time1.endTime) ||
    // moment(time2.endTime).isBetween(time1.startTime, time1.endTime)


    // )

    if (moment(time1.startTime).isSame(moment(time2.startTime)) ||
      moment(time1.endTime).isSame(moment(time2.endTime)) ||
      (moment(time1.startTime).isSame(moment(time2.startTime)) && moment(time1.endTime).isSame(moment(time2.endTime))) ||
      moment(time1.startTime).isBetween(time2.startTime, time2.endTime) ||
      moment(time1.endTime).isBetween(time2.startTime, time2.endTime) ||
      moment(time2.startTime).isBetween(time1.startTime, time1.endTime) ||
      moment(time2.endTime).isBetween(time1.startTime, time1.endTime)
    ) {
      return true;
    } else {
      if (((moment(time2.startTime).day() === moment(time1.endTime).day() || moment(time2.endTime).day() === moment(time1.startTime).day())
        && ((moment(time2.startTime).isBefore(moment(time1.endTime)) && !moment(time2.endTime).isSameOrBefore(time1.endTime)) ||
          (moment(time1.endTime).isAfter(moment(time2.startTime)) && !moment(time1.startTime).isSameOrAfter(moment(time2.endTime)))))
      ) {
        return true;
      } else {
        return false;
      }
    }
  };
  const renderCalculatedPrice = (item, index) => {
    const arrShifts = [...item.shifts];
    arrShifts.sort((a, b) => (LIST_SHIFT_TYPE[a.shiftType] - LIST_SHIFT_TYPE[b.shiftType]))
    return (
      <Box key={index}>
        <Typography key={index} variant="h5" className={classNames([classes.commonText, 'mt-2'])}>
          {t(`label.${item.dayType}`.toLowerCase())}
        </Typography>
        <Box pl={3}>
          {arrShifts.map((shift, index) => {
            var totalPrice = 0;
            var totalHours = 0;
            var price = 0;
            var shiftType = shift.shiftType;
            if (shift.rate || shift.rate === 0) {
              totalPrice = shift.totalPrice;
              totalHours = shift.totalHours;
              price = shift.rate;
            } else {
              totalPrice = shift.segmentPrice ? shift.segmentPrice : (shift.remainingPrice ? shift.remainingPrice : 0);
              totalHours = shift.segmentHours ? shift.segmentHours : (shift.remainingHours ? shift.remainingHours : 0);
              price = shift.segmentRateHours ? shift.segmentRateHours : (shift.mainRateHours ? shift.mainRateHours : 0);
            }

            return (
              <React.Fragment key={index}>
                <Grid container>
                  <Grid item sm={9}>
                    <Typography variant="h5" className={classNames([classes.commonText, 'mt-2'])}>
                      <strong>{totalHours} {t('label.hour', { count: totalHours }).toLowerCase()} </strong>
                      {t(`label.${shiftType}_at`.toLowerCase())}
                      <strong> {`$${AppUtil.formatMoney(price)}/${t('label.hour').toLowerCase()}`}</strong>
                    </Typography>
                  </Grid>
                  <Grid item sm={3}>
                    <Typography variant="h5" className={classNames([classes.commonText, 'mt-2'])}>
                      <strong> ${AppUtil.formatMoney(totalPrice)}</strong>
                    </Typography>
                  </Grid>
                </Grid>
                {arrShifts.length - 1 === index && arrShifts.length > 1 &&
                  <>
                    <Grid container>
                      <Grid item sm={9}>
                        <Typography variant="h5" className={classNames([classes.commonText, 'mt-2'])}>
                          <strong>{t('label.sub_total')}:</strong>
                        </Typography>
                      </Grid>
                      <Grid item sm={3}>
                        <Typography variant="h5" className={classNames([classes.commonText, 'mt-2'])}>
                          <strong> ${AppUtil.formatMoney(item.totalPrice)}</strong>
                        </Typography>
                      </Grid>
                    </Grid>
                    {<hr style={{ marginLeft: 0, width: '90%' }}></hr>}
                  </>
                }
              </React.Fragment>
            )
          })}
        </Box>
      </Box>
    )
  }

  useEffect(() => {
    if (!isCompany) {
      _loadParticipants();
      _loadClientDetail();
    }
    if (isCOP && data.workerType === WORKER_TYPE.NURSE) {
      _loadSupports();
    }
    if (isCompany) {
      if (data.workerType === WORKER_TYPE.NURSE) {
        _loadSupports();
        loadInits();
        loadClientIds();
      } else {
        loadClientIds();
        loadInits();
      }
    }
  }, [])

  if (loading) return <Loading />
  return (
    <Box>
      <Typography variant="h3" className={classNames([classes.availabilityTitle])}>
        {t("title.availability")}
      </Typography>
      <Typography variant="body1" className={classNames([classes.availabilityDate, 'mt-3'])}>
        {t("label.start_end_date")}
        {isMobile && <br />}
        <strong> {moment(currentWeek.startDate).format('DD/MM/YYYY')}
          - {moment(currentWeek.endDate).format('DD/MM/YYYY')}</strong>
      </Typography>
      <Formik
        enableReinitialize
        innerRef={availabilityForm}
        initialValues={initializeData}
        onSubmit={_submit}
        validationSchema={Yup.object().shape({
          monday: dayValidate,
          tuesday: dayValidate,
          wednesday: dayValidate,
          thursday: dayValidate,
          friday: dayValidate,
          saturday: dayValidate,
          sunday: dayValidate,
          specialty: isHospital && data.workerType === WORKER_TYPE.NURSE
            ? Yup.string().required('validation.required') : Yup.string(),
          support: data.workerType === WORKER_TYPE.SUPPORT_WORKER
            ? Yup.string().required('validation.required') : Yup.string(),
          job: Yup.object().shape({
            description: Yup.string()
              .required('validation.required')
              .trim()
              .max(1000, {
                message: 'validation.max_length',
                value: 1000
              }),
            address1: YupValidations.requiredString,
            address2: Yup.string()
              .max(240, {
                message: 'validation.max_length',
                value: 240
              }),
            department: isHospital ? Yup.string()
              .max(64, {
                message: 'validation.max_length',
                value: 64
              }) : Yup.string(),
            floor: isHospital ? Yup.string()
              .max(64, {
                message: 'validation.max_length',
                value: 64
              }) : Yup.string(),
            phoneNumber: Yup.string()
              .required('validation.required')
              .max(15, {
                message: 'validation.max_length',
                value: 15
              }),
            participantId: isCO || isCompany ? Yup.string().required('validation.required') : Yup.string(),
            lat: Yup.string().nullable(),
            lng: Yup.string().nullable(),
            postalCode: Yup.string()
              .required('validation.required')
          })
        })}
      >
        {({ handleSubmit, handleChange, values, resetForm, setFieldTouched }) => {
          const _onWeekChange = (week) => {
            setIsLoading(true);
            if (parseInt(week) < moment().isoWeek()) {
              setIsLoading(false);
              return;
            }
            const map = new Map(weeksData);
            map.set(currentWeek.week, values);
            setWeeksData(map);
            let newWeek;

            if (weeks.findIndex(e => e.week.toString() === week) > -1) {
              newWeek = weeks.find(e => e.week.toString() === week);
            } else {
              newWeek = _createWeeks(parseInt(week))
            }
            if (newWeek) {
              setCurrentWeek(newWeek);
              const days = _createDays(newWeek);
              _loadAvailability(newWeek)
                .then((payload) => {
                  // resetForm();
                  let isUpdate = false;
                  // check isUpdate
                  if (map.has(week) && payload) {
                    payload.forEach(item => {
                      for (const day in map.get(week)) {
                        if (moment(item.date).format('YYYY/MM/DD') === moment(map.get(week)[day].date).format('YYYY/MM/DD')) {
                          if (item.shifts.length === map.get(week)[day].shift.length) {
                            isUpdate = false;
                            return isUpdate;
                          } else {

                            isUpdate = true;
                            return isUpdate;
                          }
                        } else {
                          isUpdate = true;
                          return isUpdate;
                        }
                      }
                    });
                  }
                  // handle when newWeek is not in map
                  if (map.has(week) && !isUpdate) {
                    // resetForm();
                    if (!payload || (payload && payload.length === 0)) {
                      resetForm();
                      setInitializeData({ ...INITIALIZE_FORM });
                    } else {
                      setInitializeData(map.get(week));
                    }
                    setIsLoading(false);
                  }
                  else {
                    isUpdate = false;
                    if (!payload || (payload && payload.length === 0)) {
                      resetForm();
                      setInitializeData({ ...INITIALIZE_FORM });
                    }
                    else {
                      let bookingHistoryList = [];
                      days.forEach(item => {
                        const date = moment(item.date).format('YYYY/MM/DD');
                        const available = payload.find(e => moment(e.date).format('YYYY/MM/DD') === date.toString());

                        if (available) {
                          // already in map
                          if (map.get(week)) {
                            for (const day in map.get(week)) {
                              if (moment(available.date).format('YYYY/MM/DD') === moment(map.get(week)[day].date).format('YYYY/MM/DD')) {
                                // check map.get(week)[day] is a day?
                                if (map.get(week)[day].shift && map.get(week)[day].shift.length === available.shifts.length) {
                                  handleChange({
                                    target: {
                                      name: item.key,
                                      value: {
                                        date: date,
                                        shift: map.get(week)[day].shift.map(itemShift => {
                                          itemShift.bookingList.forEach((booking) => {
                                            bookingHistoryList.push({
                                              day: item.key,
                                              shiftType: itemShift.shiftType,
                                              date: date,
                                              startTime: moment(booking.startTime),
                                              endTime: moment(booking.endTime)
                                            });
                                          });
                                          return {
                                            ...itemShift
                                          }
                                        })
                                      }
                                    }
                                  })
                                } else {
                                  // is not a day
                                  // setCalculatedPrice(INITIALIZE_CALCULATED_PRICE);
                                  // handleChange({
                                  //     target: {
                                  //         name: item.key,
                                  //         value: {
                                  //             date: date,
                                  //             shift: available.shifts.map(itemShift => {
                                  //                 const newList = itemShift.bookingList.map((booking) => {
                                  //                     let start = booking.startTime && moment(booking.startTime).set({
                                  //                         year: moment().get('year'),
                                  //                         month: moment().get('month'),
                                  //                         date: moment().get('date')
                                  //                     });
                                  //                     let end = booking.endTime && moment(booking.endTime).set({
                                  //                         year: moment().get('year'),
                                  //                         month: moment().get('month'),
                                  //                         date: moment().get('date')
                                  //                     });
                                  //                     switch (booking.shiftType) {
                                  //                         case 'NIGHT': {
                                  //                             if (start && start.hours() <= now.hours()) {
                                  //                                 start = start.add(1, 'day');
                                  //                             }
                                  //                             if (end && end.hours() <= now.hours()) {
                                  //                                 end = end.add(1, 'day');
                                  //                             }
                                  //                             break;
                                  //                         }
                                  //                         case 'EVENING': {
                                  //                             if (start && start.hours() <= 6) {
                                  //                                 start = start.add(1, 'day');
                                  //                             }
                                  //                             if (end && end.hours() <= 6) {
                                  //                                 end = end.add(1, 'day');
                                  //                             }
                                  //                             break;
                                  //                         }
                                  //                     }
                                  //                     return {
                                  //                         start: start.format('YYYY/MM/DD HH:mm'),
                                  //                         end: end.format('YYYY/MM/DD HH:mm')
                                  //                     }

                                  //                 });
                                  //                 return {
                                  //                     ...itemShift,
                                  //                     bookingList: newList,
                                  //                     startDate: undefined,
                                  //                     endDate: undefined,
                                  //                     start: undefined,
                                  //                     end: undefined,
                                  //                     type: itemShift.shiftType,
                                  //                     checked: false
                                  //                 }                                                                                
                                  //             })
                                  //         }
                                  //     }
                                  // })
                                }
                              } else {
                                // handleChange({
                                //     target: {
                                //         name: item.key,
                                //         value: {
                                //             date: date,
                                //             shift: available.shifts.map(item => {
                                //                 let start = item.startTime && moment(item.startTime).set({
                                //                     year: moment().get('year'),
                                //                     month: moment().get('month'),
                                //                     date: moment().get('date')
                                //                 });
                                //                 let end = item.endTime && moment(item.endTime).set({
                                //                     year: moment().get('year'),
                                //                     month: moment().get('month'),
                                //                     date: moment().get('date')
                                //                 });
                                //                 if (item.shiftType === 'NIGHT') {
                                //                     if (start && start.hours() <= 6) {
                                //                         start = start.add(1, 'day');
                                //                     }
                                //                     if (end && end.hours() <= 6) {
                                //                         end = end.add(1, 'day');
                                //                     }
                                //                 }
                                //                 return {
                                //                     ...item,
                                //                     start: start && start.format('YYYY/MM/DD HH:mm'),
                                //                     end: end && end.format('YYYY/MM/DD HH:mm'),
                                //                     type: item.shiftType,
                                //                     checked: false
                                //                 }
                                //             })
                                //         }
                                //     }
                                // })
                              }
                            }
                          } else {
                            // not already in map
                            handleChange({
                              target: {
                                name: item.key,
                                value: {
                                  date: date,
                                  shift: available.shifts.map(itemShift => {
                                    const newList = itemShift.bookingList.map((booking) => {
                                      bookingHistoryList.push({
                                        day: item.key,
                                        shiftType: itemShift.shiftType,
                                        date: date,
                                        startTime: moment(booking.startTime),
                                        endTime: moment(booking.endTime)
                                      });
                                      return {
                                        startTime: moment(booking.startTime),
                                        endTime: moment(booking.endTime)
                                      }

                                    });
                                    return {
                                      ...itemShift,
                                      bookingList: newList,
                                      type: itemShift.shiftType,
                                      startDate: undefined,
                                      endDate: undefined,
                                      start: undefined,
                                      end: undefined,
                                      checked: false
                                    }
                                  })
                                }
                              }
                            })
                          }
                        } else {
                          handleChange({
                            target: {
                              name: item.key,
                              value: { ...DAY }
                            }
                          })
                        }
                      })
                      bookingHistoryList.sort(function (a, b) { return moment.range(b.startTime, a.startTime).diff('minutes') });
                      setBookingHistoryList(bookingHistoryList);
                    }
                    setIsLoading(false);
                  }
                });
            }
          }
          return (
            isLoading ? <Loading /> :
              <Box>
                {/* pagination */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mt={3} flexDirection={isMobile ? 'column' : 'row'}>
                  <Typography variant="body1" className={classNames([classes.availabilitySubTitle])}>
                    {t('text.tap_on_shift')}
                  </Typography>
                  <Box display="flex" justifyContent="flex-end" alignItems="center">
                    <IconButton
                      onClick={() => _onWeekChange(currentWeek.week - 1)}
                      disabled={isLoading}
                    >
                      <KeyboardArrowLeft />
                    </IconButton>
                    <Typography className={classes.weekSelect}>
                      {currentWeek.label}
                    </Typography>
                    <IconButton
                      onClick={() => _onWeekChange(currentWeek.week + 1)}
                      disabled={isLoading}
                    >
                      <KeyboardArrowRight />
                    </IconButton>
                  </Box>
                </Box>
                {/* header table */}
                <Box
                  className={classNames([classes.box1])}
                  display="flex" justifyContent="space-between"
                  alignItems="center"
                >
                  <Box p={2} className={classes.innerBox} style={{ width: '30.25%' }}>
                    <Typography variant="h5" className={classes.subTitle}>
                      {isMobile ? '' : t('label.day_shift')}
                    </Typography>
                  </Box>
                  <Box p={2} className={classes.innerBox} style={{ width: `${70 / 4}%`, height: '100%' }}>
                    <Typography variant="h5" className={classes.title}>
                      {isMobile ? 'DST' : t('label.morning')}
                    </Typography>
                  </Box>
                  <Box p={2} className={classes.innerBox} style={{ width: `${70 / 4}%`, height: '100%' }}>
                    <Typography variant="h5" className={classes.title}>
                      {isMobile ? 'NGT' : t('label.afternoon')}
                    </Typography>
                  </Box>
                  <Box p={2} className={classes.innerBox} style={{ width: `${70 / 4}%`, height: '100%' }}>
                    <Typography variant="h5" className={classes.title}>
                      {isMobile ? 'ATN' : t('label.evening')}
                    </Typography>
                  </Box>
                  <Box p={2} style={{ width: `${70 / 4}%` }}>
                    <Typography variant="h5" className={classes.title}>
                      {isMobile ? 'SLO' : t('label.sleepover')}
                    </Typography>
                  </Box>
                </Box>
                <div style={{ height: '2px' }} />
                {/* body table */}
                <Box
                  display="flex" justifyContent="space-between" alignItems="center"
                >
                  <Box
                    style={{ width: '30%' }}
                    className={classes.box1}
                  >
                    {days.map((item, index) => (
                      <Box
                        key={index}
                        display="flex" justifyContent="space-between" alignItems="center"
                      >
                        <Box
                          p={2} className={classes.innerBox2} style={{ width: isMobile ? '50%' : '60%' }}
                          display="flex" justifyContent="center" alignItems="center"
                        >
                          <Typography variant="h5" className={classes.title}>
                            {isMobile ? item.shortText : t(item.label)}
                          </Typography>
                        </Box>
                        <Box
                          p={2} className={classes.innerBox3} style={{ width: isMobile ? '50%' : '40%' }}
                          display="flex" justifyContent="center" alignItems="center"
                        >
                          <Typography variant="h5" className={classes.date}>
                            {moment(item.date).format('DD/MM')}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                  <div style={{ width: '2px' }} />
                  <Box
                    className={classes.box2}
                    style={{ width: '70%' }}
                  >
                    {days.map((item, index) => {
                      const available = values?.[item.key];
                      let morning, afternoon, evening, night;
                      let arrAvailable = [];
                      if (available) {
                        morning = available.shift.find(e => e.shiftType === 'MORNING') || {};
                        afternoon = available.shift.find(e => e.shiftType === 'AFTERNOON') || {};
                        evening = available.shift.find(e => e.shiftType === 'EVENING') || {};
                        night = available.shift.find(e => e.shiftType === 'NIGHT') || {};

                        arrAvailable = [morning, afternoon, evening, night];
                      } else {
                        arrAvailable = [{}, {}, {}, {}];
                      }
                      // console.log('arrAvailable', arrAvailable);
                      return (
                        <Box
                          key={`day-${index}`}
                          display="flex" justifyContent="space-between" alignItems="center"
                        >
                          {
                            arrAvailable.map((avl, i) => {
                              const index = values?.[item.key]?.shift?.findIndex(e => e.type === avl.shiftType);
                              // if (avl.checked && avl.start && avl.end) {
                              //     console.log('\n\n >>>>>> avl: ',  {
                              //         ...avl,
                              //         start: moment(avl.start).format('DD/MM/YYYY HH:mm'),
                              //         end: moment(avl.end).format('DD/MM/YYYY HH:mm'),
                              //     });
                              // }

                              // const currentEnd = getIn(values, `${item.key}.shift.[${index}].end`);
                              // const currentStart = getIn(values, `${item.key}.shift.[${index}].start`);
                              const isOverDay = moment.range(moment(), moment(item.date)).diff('day') < 0;
                              const dataList = bookingHistoryList.filter((data) => (data.date === moment(item.date).format('YYYY/MM/DD') && data.shiftType == avl.shiftType));
                              return (
                                // col
                                <Box
                                  key={`avl-${avl.id}-${i}`}
                                  style={{ width: `${100 / 4}%` }}
                                  className={(i === days.length - 1) ? classes.innerBox4 : classes.innerBox2}
                                  display="grid"
                                  px={1}
                                >
                                  {
                                    avl && avl.id &&
                                    <>
                                      {dataList.length > 0 && dataList.length <= 1 &&
                                        <Box display="flex" justifyContent="center"
                                          className={avl.available ? classes.boxVisibilityIconBottom : classes.boxVisibilityIconCenter}
                                        >
                                          {dataList[0].startTime.format('HH:mm') + ' - ' + dataList[0].endTime.format('HH:mm')}
                                        </Box>}
                                      {dataList.length > 1 &&
                                        <Box display="flex"
                                          justifyContent="center"
                                          className={(avl.available) ? classes.boxVisibilityIconBottom : classes.boxVisibilityIconCenter}
                                        >
                                          <u className={classes.textViewMoreBooking} onClick={() => {
                                            setShowModal({ day: item.key, shiftType: avl.shiftType, date: item.date });
                                          }}>
                                            {t('label.viewMoreBooking')}
                                          </u>
                                        </Box>}
                                      {
                                        (avl.available || (dataList.length === 0)) &&
                                        <Box display="flex" justifyContent="center" alignItems={dataList.length > 0 ? 'flex-start' : "center"}>
                                          <Checkbox
                                            style={avl.available ? isOverDay ? undefined : { color: AppColor.availability, padding: 0 } : undefined}
                                            checked={avl.checked}
                                            onChange={(event, checked) => {
                                              if (!checked) {
                                                setFieldTouched(`${item.key}.shift.[${index}].start`, false);
                                                setFieldTouched(`${item.key}.shift.[${index}].end`, false);
                                              }
                                              if (checked) {
                                                _handleOpenBookingPopup(avl.shiftType, event, checked, values, item, avl.id, handleChange);
                                              } else {
                                                _handleClearDataBooking(avl.shiftType, event, checked, values, item, avl.id, handleChange);
                                              }
                                              // _handleCheckboxChange(avl.shiftType, event, checked, values, item, avl.id, handleChange);
                                            }}
                                            disabled={!avl.available || isOverDay}
                                          />
                                        </Box>
                                      }
                                      {/* {dataList.length > 0 && avl.available && !isFullTimeSlot && !values?.[item.key]?.shift[index].checked &&
                                                                            <Box className={classes.boxEmpty}>Empty</Box>} */}
                                      {avl.checked &&
                                        <Box className={classes.wrapShift} onClick={() => _handleUpdateBooking(avl.shiftType, true, values, item, avl.id, handleChange)}>
                                          <Box
                                            className={`shiftInfo ${avl.shiftType}`}
                                          >
                                            <span style={{ width: '100%', textAlign: 'center' }}>{t(`shift.${avl.shiftType}`)} {`${moment(avl.start).format("HH:mm")} - ${moment(avl.end).format("HH:mm")}`}</span>
                                          </Box>
                                        </Box>
                                      }
                                    </>
                                  }
                                </Box>
                              )
                            })
                          }
                        </Box>
                      )
                    })}
                  </Box>
                </Box>
                {/* info job */}
                <Box mx={isMobile ? 1 : 5} mt={5}>
                  <Box>
                    <Typography variant="h5" className={classes.commonTitle}>
                      {t('title.estimated_price')}
                    </Typography>
                    <Field
                      component={SelectField}
                      label={isHospital ? t('label.select_a_specialty') : t('label.select_a_support')}
                      name={isHospital ? 'specialty' : 'support'}
                      placeholder={isHospital ? t('label.select_a_specialty') : t('label.select_a_support')}
                      type="select"
                      required
                      options={
                        isHospital
                          ? data?.specialties && data?.specialties?.map(item => {
                            return { value: item.id, label: item.name };
                          })
                          : isCOP && data.workerType === WORKER_TYPE.NURSE
                            ? supports.map(item => {
                              return { value: item.id, label: item.name }
                            })
                            : isCOP && data?.supports
                              ? data?.supports?.map(item => {
                                return { value: item.id, label: item.name }
                              })
                              : isCompany ?
                                data?.supports ? data?.supports?.map(item => {
                                  return { value: item.id, label: item.name }
                                }) : [] : []
                      }
                      onSelected={(value) => {
                        isHospital ? _onSpecialtyChange(value, values) : _onSupportChange(value, values)
                      }}
                    />
                    <Box mx={isMobile ? 1 : 5} my={isMobile ? 1 : 2} p={isMobile ? 1 : 3} className={classes.totalBox}>
                      <Grid container spacing={isMobile ? 1 : 3}>
                        <Grid item sm={9}>
                          <Typography variant="h5" className={classes.commonText}>
                            {t('label.time')}
                          </Typography>

                        </Grid>
                        <Grid item sm={3}>
                          <Typography variant="h5" className={classes.commonText}>
                            {t('label.total')}
                          </Typography>
                          {/* <Typography variant="h5" className={classNames([classes.commonText, 'mt-2'])}>
                            { <strong>${AppUtil.formatMoney(calculatedPrice.totalPrice)}</strong>}
                          </Typography> */}
                        </Grid>
                      </Grid>
                      {calculatedPrice.dayTypes.map((item, index) => item.dayType === 'WEEK_DAY' &&
                        renderCalculatedPrice(item, index))}
                      {calculatedPrice.dayTypes.map((item, index) => item.dayType === 'SAT_WEEK_END' &&
                        renderCalculatedPrice(item, index))}
                      {calculatedPrice.dayTypes.map((item, index) => item.dayType === 'WEEK_END' &&
                        renderCalculatedPrice(item, index))}
                      {calculatedPrice.dayTypes.map((item, index) => item.dayType === 'HOLIDAY' &&
                        renderCalculatedPrice(item, index))}
                      <Grid container>
                        <Grid item sm={12}>
                          {calculatedPrice?.dayTypes?.length === 1 && <hr style={{ marginLeft: 0, width: '90%' }}></hr>}
                        </Grid>
                        <Grid item sm={9}>
                          <Typography variant="h5" className={classNames([classes.commonText, 'mt-2'])}>
                            <strong>{t('label.total')}:</strong>
                          </Typography>
                        </Grid>
                        <Grid item={3}>
                          <Typography variant="h5" className={classNames([classes.commonText, 'mt-2'])}>
                            <strong style={{ marginLeft: 6 }}> ${AppUtil.formatMoney(calculatedPrice?.totalPrice)}</strong>
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                  <Box mt={3}>
                    <Typography variant="h5" className={classes.commonTitle}>
                      {t('title.job_information')}
                    </Typography>
                    <Box>
                      <Field
                        label={t('label.job_description')}
                        component={AppInput}
                        name="job.description"
                        type="textarea"
                        required
                      />
                    </Box>
                    <Grid container spacing={3}>
                      <Grid item sm={12} md={6}>
                        {isCompany && (
                          <Field
                            component={SelectField}
                            label={t('label.participant')}
                            name="job.participantId"
                            placeholder={t('label.select_a_participant')}
                            type="select"
                            required
                            options={clientIds
                              .filter((item) => {
                                if (
                                  item.status === "DEACTIVATE" &&
                                  item.id !== values.job.participantId
                                ) {
                                  return false;
                                }
                                return true;
                              })
                              .map((item) => {
                                return {
                                  value: item.id,
                                  label: `${item?.firstName} ${item?.lastName}`,
                                };
                              })}
                            onSelected={(value) => {
                              const index = clientIds.findIndex(e => e.id.toString() === value.toString());
                              if (index > -1) {
                                const participant = clientIds[index];
                                handleChange({
                                  target: {
                                    name: 'job.address1',
                                    value: participant?.address1
                                  }
                                })
                                handleChange({
                                  target: {
                                    name: 'job.address2',
                                    value: participant?.address1
                                  }
                                })
                                handleChange({
                                  target: {
                                    name: 'job.phoneNumber',
                                    value: participant?.phone
                                  }
                                })
                                handleChange({
                                  target: {
                                    name: 'job.floor',
                                    value: participant?.floor
                                  }
                                })
                                handleChange({
                                  target: {
                                    name: 'job.department',
                                    value: participant?.department
                                  }
                                })
                                handleChange({
                                  target: {
                                    name: 'job.postalCode',
                                    value: participant?.postalCode
                                  }
                                })
                                handleChange({
                                  target: {
                                    name: 'job.lat',
                                    value: participant?.lat
                                  }
                                })
                                handleChange({
                                  target: {
                                    name: 'job.lng',
                                    value: participant?.lng
                                  }
                                })
                              }
                            }}
                          />
                        )}
                        {isCO && (
                          <Field
                            component={SelectField}
                            label={t('label.participant')}
                            name="job.participantId"
                            placeholder={t('label.select_a_participant')}
                            type="select"
                            required
                            options={participants
                              .filter((item) => {
                                if (
                                  item.status === "DEACTIVATE" &&
                                  item.id !== values.job.participantId
                                ) {
                                  return false;
                                }
                                return true;
                              })
                              .map((item) => {
                                return {
                                  value: item.id,
                                  label: `${item.firstName} ${item.lastName}`,
                                };
                              })}
                            onSelected={(value) => {
                              const index = participants.findIndex(e => e.id.toString() === value.toString());
                              if (index > -1) {
                                const participant = participants[index];
                                handleChange({
                                  target: {
                                    name: 'job.address1',
                                    value: participant.address1
                                  }
                                })
                                handleChange({
                                  target: {
                                    name: 'job.address2',
                                    value: participant.address1
                                  }
                                })
                                handleChange({
                                  target: {
                                    name: 'job.phoneNumber',
                                    value: participant.phone
                                  }
                                })
                                handleChange({
                                  target: {
                                    name: 'job.floor',
                                    value: participant.floor
                                  }
                                })
                                handleChange({
                                  target: {
                                    name: 'job.department',
                                    value: participant.department
                                  }
                                })
                                handleChange({
                                  target: {
                                    name: 'job.postalCode',
                                    value: participant.postalCode
                                  }
                                })
                                handleChange({
                                  target: {
                                    name: 'job.lat',
                                    value: participant.lat
                                  }
                                })
                                handleChange({
                                  target: {
                                    name: 'job.lng',
                                    value: participant.lng
                                  }
                                })
                              }
                            }}
                          />
                        )}
                        <Field
                          component={InputAutocompleteAddress}
                          label={t('label.address1')}
                          name="job.address1"
                          type="textarea"
                          required
                          onChangeLatLng={(e) => {
                            handleChange({
                              target: {
                                name: 'job.lat',
                                value: `${e.lat}`
                              }
                            })
                            handleChange({
                              target: {
                                name: 'job.lng',
                                value: `${e.lng}`
                              }
                            })
                          }}
                          onChangePostalCode={(postCode) => {
                            handleChange({
                              target: {
                                name: 'job.postalCode',
                                value: `${postCode}`
                              }
                            })
                          }}
                        />
                        {!isCO && (
                          <Field
                            component={AppInput}
                            label={t('label.address2')}
                            name="job.address2"
                            type="textarea"
                          />
                        )}
                      </Grid>
                      <Grid item sm={12} md={6}>
                        {isHospital && (
                          <Field
                            component={AppInput}
                            label={t('label.department')}
                            name="job.department"
                          />
                        )}
                        {isHospital && (
                          <Field
                            component={AppInput}
                            label={t('label.floor')}
                            name="job.floor"
                          />
                        )}
                        <Field
                          component={AppInput}
                          label={t('label.phone_number')}
                          name="job.phoneNumber"
                          required
                        />
                        <Field
                          component={AppInput}
                          label={t('label.postal_code')}
                          name="job.postalCode"
                          mask={MASK.PHONE}
                          maskChar=""
                          type="tel"
                          required
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  <Box mt={3} display="flex" alignItems="center" justifyContent="center">
                    <AppButton
                      label={t('button.book')}
                      onClick={handleSubmit}
                      disabled={submitting}
                      isLoading={submitting}
                    />
                  </Box>
                </Box>
                <Modal isOpen={showModal !== null} toggle={() => setShowModal(null)}>
                  <ModalHeader toggle={() => setShowModal(null)}>
                    {t('label.bookingHistory')}
                  </ModalHeader>
                  <ModalBody style={{ minWidth: '400px', minHeight: '400px' }}>
                    {bookingHistoryList && renderDataModal()}
                  </ModalBody>
                </Modal>

              </Box>
          )
        }}
      </Formik>
      <AppDialog
        open={isOpenModalBooking}
        onClose={() => _handleCloseModalBooking(newBooking)}
        maxWidth="xs"
        title={newBooking?.isUpdate ? t('title.updateBooking') : t('title.createBooking')}
      >
        <Box>
          <ShiftForm
            onCancel={_handleCloseModalBooking}
            onSubmit={_handleAddNewBooking}
            newBooking={newBooking}
            checkValidateBookingTime={checkValidateBookingTime}
            setInvalidMap={setInvalidMap}
            invalidMap={invalidMap}
            getValidateMinMaxTime={getValidateMinMaxTime}
          />
        </Box>
      </AppDialog>
    </Box >
  )
}

BookingForm.propTypes = {
  data: PropTypes.object
}

export default BookingForm;